module.exports = __webpack_public_path__ + "img/profit.e843a6eb.png";